import { Injectable, ComponentFactoryResolver, ViewContainerRef } from '@angular/core';
import { WidgetTypeByName } from '@widgets/widget.registry';

@Injectable({
  providedIn: 'root'
})
export class SxDynamicComponentsService {

  rootViewContainer: ViewContainerRef;

  constructor(private compiler: ComponentFactoryResolver) { }

  setRootViewContainerRef(viewContainerRef: ViewContainerRef) {
    this.rootViewContainer = viewContainerRef;
  }

  addDynamicComponent(componentName: string) {
    const componentType = WidgetTypeByName(componentName + 'Component');
    const factory = this.compiler.resolveComponentFactory(componentType);
    this.rootViewContainer.clear();
    const component = this.rootViewContainer.createComponent(factory);
    return component;
  }
}
